
import { useRouter } from 'vue-router'
import {inject} from 'vue'
export default {
   props:{
     iconList:{  //数据列表
       type:Array,
       default:()=>{
         return []
       }
     },
     newline:{  //是否开启换行，默认不开启
       type:Boolean,
       default:false
     },
     linefew:{   //一行几个，默认5，可选参数，3和4
       type:Number,
       default:5
     },
     color:{  //图标颜色
        type:String,
        default:'#f76900'
     },
     colorSize:{ //字体颜色
        type:String,
        default:'#666666'
     }
     
   },
   setup(props:any){
     const router = useRouter()
      const $store: any = inject("$store");
     const designClick = (item:any):void=>{  
        common.goTo(item.type,item.data,router)
        $store.setGoBack('usercenter')
     }
    console.log("图标",props.linefew);
    
     return {
       designClick
     }
   }
}
